// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCly1tehVr2xI52RI59UaBlfZhp7sNakJY",
  authDomain: "ismailhocine-79407.firebaseapp.com",
  projectId: "ismailhocine-79407",
  storageBucket: "ismailhocine-79407.firebasestorage.app",
  messagingSenderId: "1009006796220",
  appId: "1:1009006796220:web:f44c6d259ac2bf6c1f5fb9",
  measurementId: "G-L3N681FWK2",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
